import { createApp } from 'vue';

import '@fortawesome/fontawesome-free/css/all.css';

import App from './App.vue';
import './registerServiceWorker';
import './index.css';
import './styles/design-tokens.css';
import './styles/animations.css';

import router from './router';
import { store, key } from './store';
import Quasar from 'quasar/src/vue-plugin.js';;
import { quasarConfig } from './quasar-user-options';

createApp(App).use(Quasar, quasarConfig)
  .use(router)
  .use(store, key)
  .mount('#app');
